import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { PreinscripcionComponent } from './formulario/formulario.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  { path: 'promocion', redirectTo: '/promocion/preinscripcion/lista', pathMatch: 'full' },
  {
    path: 'promocion/preinscripcion',
    children: [
       { path: 'lista', component: ListaComponent},
       { path: 'nuevo', component: PreinscripcionComponent },
       { path: 'editar/:id', component: PreinscripcionComponent},
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PreinscripcionRoutingModule { }

